'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FlatButton = require('material-ui/FlatButton');

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @desc
 * File upload button.
 *
 * @example
 * handleUpload = (files) => {
 *     uploadFiles(files.map((file) => {
 *         return {file: file, name: `prefix-${file.name}`};
 *     }));
 * }
 *
 * <FieldUploadField
 *     label="Vedlegg"
 *     multiple={true}
 *     onFile={this.handleUpload}
 * />
 */
var FileUploadField = function (_React$Component) {
    _inherits(FileUploadField, _React$Component);

    function FileUploadField() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FileUploadField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FileUploadField.__proto__ || Object.getPrototypeOf(FileUploadField)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
            var filelist = e.target.files && e.target.files.length && e.target.files;
            var files = [];
            if (files) {
                for (var i = 0; i < filelist.length; i++) {
                    files.push(filelist[i]);
                }
            }
            _this.props.onFile(files);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    /**
     * @type {Object}
     * @property {string} label Button label.
     * @property {boolean} multiple Accept multiple files.
     * @property {boolean} disabled Disable field.
     * @property {string} accept Accept string to input field.
     * @property {function(files: File[]):} onFile Callback when file(s) are selected.
     */


    /**
     * @type {Object}
     */


    /**
     * @type {function}
     */


    _createClass(FileUploadField, [{
        key: 'render',


        /**
         * @return {Node}
         */
        value: function render() {
            var _props = this.props,
                label = _props.label,
                onFile = _props.onFile,
                multiple = _props.multiple,
                accept = _props.accept,
                disabled = _props.disabled,
                other = _objectWithoutProperties(_props, ['label', 'onFile', 'multiple', 'accept', 'disabled']);

            return _react2.default.createElement(
                _FlatButton2.default,
                _extends({
                    containerElement: 'label',
                    label: label,
                    disabled: disabled
                }, other),
                _react2.default.createElement('input', {
                    type: 'file',
                    style: {
                        opacity: 0,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0
                    },
                    onChange: this.handleChange,
                    multiple: multiple,
                    accept: accept,
                    disabled: disabled
                })
            );
        }
    }]);

    return FileUploadField;
}(_react2.default.Component);

FileUploadField.propTypes = {
    label: _propTypes2.default.string.isRequired,
    onFile: _propTypes2.default.func,
    multiple: _propTypes2.default.bool,
    accept: _propTypes2.default.string,
    disabled: _propTypes2.default.bool
};
FileUploadField.defaultProps = {
    label: 'Last opp',
    multiple: false,
    accept: undefined,
    disabled: false,
    onFile: function onFile() {
        return undefined;
    }
};
exports.default = FileUploadField;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/material/FileUploadField.js
// module id = 1118
// module chunks = 0